import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const autodesk = defineConnector({
  identifier: "autodesk",
  name: "Autodesk",
  tagLine: "Design and engineering software",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://developer\\.api\\.autodesk\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an Autodesk app",
      items: [
        {
          kind: "markdown",
          content:
            "Open [Autodesk Platform Services My Apps](https://aps.autodesk.com/myapps), create an app, and choose the APIs your integration needs. Copy the client ID and client secret from the app details page.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/autodesk/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Autodesk account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Autodesk account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://developer.api.autodesk.com/authentication/v2/authorize",
    tokenEndpoint: () =>
      "https://developer.api.autodesk.com/authentication/v2/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://developer.api.autodesk.com/",
  },
});
